export default [
  {
    prop: 'logo_url',
    label: '应用图标',
    minWidth: 80,
    tooltip: true
  },
  {
    prop: 'app_name',
    label: '应用名称',
    minWidth: 130,
    tooltip: true
  },
  {
    prop: 'appid',
    label: '支付宝APPID',
    minWidth: 180,
    tooltip: true
  },
  {
    prop: 'mch',
    label: '商户号',
    minWidth: 180,
    tooltip: true
  },
  {
    prop: 'main_company_name',
    label: '公司主体',
    minWidth: 160,
    tooltip: true
  },
  {
    prop: 'download_url',
    label: '下载链接',
    minWidth: '200px',
    tooltip: true
  },
  {
    prop: 'app_user_agreement_url',
    label: 'APP用户协议',
    minWidth: '200px',
    tooltip: true
  },
  {
    prop: 'status',
    label: '状态',
    minWidth: '100px'
  },
  {
    prop: 'reject_msg',
    label: '拒绝原因',
    minWidth: '150px',
    tooltip: true
  },
  {
    prop: 'action',
    width: '100px',
    label: '操作'
  }
]
